module.exports = __webpack_public_path__ + "assets/img/ferment.e9f0f1b4.png";